export default __webpack_public_path__ + "static/media/img-0571-iceland-full-face.8b280e49.png";